import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const StarBulletIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9.80561 0.96562C9.99556 0.385029 10.5289 0.00281528 11.1387 0C11.7501 0.014142 12.2844 0.409133 12.4632 1.00099L14.2076 6.77712L14.2085 6.78002C14.3662 7.31231 14.7714 7.703 15.2662 7.87753L21.026 9.77893C21.6148 9.9846 21.9972 10.5222 22 11.1471C21.9859 11.7571 21.5911 12.2912 20.9982 12.4701L15.2178 14.2132L15.2149 14.2141C14.6827 14.3716 14.2916 14.7763 14.1168 15.2712L12.2122 21.0322L12.2115 21.0344C12.0209 21.6171 11.4833 22 10.8706 22H10.8449C10.2332 21.9862 9.69854 21.5911 9.51965 20.999L7.77526 15.2229L7.77443 15.22C7.61672 14.6877 7.21154 14.297 6.71665 14.1225L0.969172 12.2195L0.966393 12.2186C0.394221 12.0316 0.00279684 11.4887 0 10.8529C0.0140949 10.2499 0.419407 9.7099 1.00353 9.52936L6.80186 7.786C7.33423 7.6286 7.72547 7.22385 7.90031 6.72882L9.8049 0.96778L9.80561 0.96562Z",
                fill: "url(#paint0_linear_29526_5939)"
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint0_linear_29526_5939",
                    x1: "23.5",
                    y1: "0.265625",
                    x2: "7",
                    y2: "14.7656",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#6161FF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#FD84E2"
                        })
                    ]
                })
            })
        ]
    });
export default StarBulletIcon;
